// ACTA_AGENT_PAGE_CONTEXT_V1

const CONTEXTS = [
  ["/app/commerce/pipeline", "commercial", "pipeline", "Affaires"],
  ["/app/commerce/quotes", "commercial", "quotes", "Devis"],
  ["/app/commerce/agenda", "commercial", "agenda", "Agenda"],
  ["/app/commerce/prospects", "commercial", "portfolio", "Contacts"],
  ["/app/commerce/stats", "commercial", "stats", "Statistiques"],
  ["/app/commerce/map", "commercial", "map", "Carte commerciale"],
  ["/app/commerce/dashboard", "commercial", "dashboard", "Accueil commercial"],

  ["/app/documents", "documents", "documents", "Documents"],

  ["/app/gmao/sav", "gmao", "sav", "Tickets SAV"],
  ["/app/gmao/interventions", "gmao", "interventions", "Interventions"],
  ["/app/gmao/planning", "gmao", "planning", "Planning"],
  ["/app/gmao/maintenance", "gmao", "maintenance", "Maintenance"],
  ["/app/gmao/machines", "gmao", "machines", "Machines"],
  ["/app/gmao/parts", "gmao", "parts", "Stock & pièces"],
  ["/app/gmao/dashboard", "gmao", "dashboard", "GMAO"],
];

export function getAgentPageContext(
  pathname = ""
) {
  const match = CONTEXTS.find(
    ([path]) =>
      pathname === path
      || pathname.startsWith(
        `${path}/`
      )
  );

  if (!match) {
    return {
      module: null,
      page: null,
      label: "Acta",
      pathname,
    };
  }

  return {
    module: match[1],
    page: match[2],
    label: match[3],
    pathname,
  };
}
